import { gql } from "@apollo/client";

export const GET_INSUMOS_LITE = gql`
query GetAllinsumos($skip : Int!, $take : Int!, $where : t_InsumoFilterInput, $order: [t_InsumoSortInput!]) {
    allinsumos(skip: $skip, take: $take, where: $where, order: $order) {
        items{
            idInsumoN
            idInsumo
            descripcion
        }
        totalCount
    }
}`;


export const adaptProducto = (producto) => {
  return {
    idInsumoN: producto?.idInsumoN,
    idInsumo: producto?.idInsumo,
    descripcion: producto?.descripcion
  };
};

export const adaptProductosArray = (
productos) =>
{
  return structuredClone(productos)?.
  map((producto) => adaptProducto(producto));
};